import { Component } from '@angular/core';
import { monitoringService } from 'app/shared/services/monitoring/monitoring.module';

@Component({ 
    template: '', 
}) 
export class BaseComponent { 

    // private monitoringService: MonitoringService;

    constructor() {} 

    private logNavigation() { 
        // don't need to specfiy the name and url as this is automatically worked out by the AppInsights method
        monitoringService.logPageView(); 
    } 
}
